import React, { useState, useEffect, useRef } from "react";
import NavMain from "../components/nav/NavMain";
import HeaderApplicant from "../components/header/HeaderApplicant";
import { useParams } from "react-router-dom";
import axios from "axios";
import { format } from 'date-fns';
import GLOBALVAR from "../constants";
import { Col, Container, Row, Button, Modal } from "react-bootstrap";
import EditApplicant from "../components/modals/EditApplicant";
import { useNavigate } from 'react-router-dom';
import ApplicantProcessedLoans from "../components/misc/ApplicantProcessedLoans";
import "../css/applicant-page.scss";


function ApplicantPage() {
    const { id } = useParams();
    const [applicant, setApplicant] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);
    const handleCloseDelete = () => setShowModalDelete(false);
    const handleShowDelete = () => setShowModalDelete(true);
    const [loanProcessed, setLoanProcessed] = useState(null);
    const navigate = useNavigate();
    const [isDeleting, setIsDeleting] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [deleteResult, setDeleteResult] = useState(null);

    const fetchApplication = async (id) => {
        try {
            const response = await axios.get(`${GLOBALVAR['SERVER_ROOT']}/api/applications/${id}`); // Replace '/api/applications/' with your actual endpoint
            const application = response.data;
            // Display application data in the frontend
            setLoanProcessed(application.loanProcessings);
            setApplicant(application);
        } catch (error) {
            console.error('Error fetching application:', error);
            // Handle error
        }
    };

    const handleDeleteProcess = async (id) => {
        if (!id) return;
        
        setIsDeleting(true);
        try {
            const response = await axios.delete(`${GLOBALVAR['SERVER_ROOT']}/api/application/${id}`);
            
            if (response.data.status === 'success') {
                setDeleteResult(response.data.details);
                handleCloseDelete(); // Close delete confirmation modal
                setShowSuccessModal(true); // Show success modal
            }
        } catch (error) {
            console.error('Error deleting application:', error);
            handleCloseDelete();
            // Add error handling here
        } finally {
            setIsDeleting(false);
        }
    };

    const handleSuccessClose = () => {
        setShowSuccessModal(false);
        // Navigate after modal is closed
        navigate('/', { 
            state: { 
                message: 'Application deleted successfully',
                type: 'success'
            }
        });
    };

    // Function to update the applicant state in the parent component
    const updateParentApplicant = (newApplicantData) => {
        setApplicant(newApplicantData);
    };

    useEffect(() => {
        fetchApplication(id);
    }, [id]);

    // Add ref for resize observer
    const processedLoansRef = useRef(null);

    // Add cleanup for resize observer
    useEffect(() => {
        let resizeObserver;
        
        if (processedLoansRef.current) {
            resizeObserver = new ResizeObserver(() => {
                window.requestAnimationFrame(() => {
                    if (processedLoansRef.current) {
                        const element = processedLoansRef.current;
                        // Store display value
                        const originalDisplay = element.style.display;
                        
                        // Force reflow properly
                        element.style.display = 'none';
                        // Use void to properly handle the expression
                        void element.offsetHeight;
                        // Restore display
                        element.style.display = originalDisplay;
                    }
                });
            });

            resizeObserver.observe(processedLoansRef.current);
        }

        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, []);

    return (
        <>
            <Modal show={showModal} onHide={handleClose} className="edit-app-details">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditApplicant applicantdb={applicant} updateParentApplicant={updateParentApplicant} />
                </Modal.Body>
            </Modal>
            <Modal show={showModalDelete} onHide={handleCloseDelete} className="delete-app-details">
                <Modal.Header closeButton>
                    <Modal.Title className="h6">Are you sure you want to delete Applicant?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-center">
                        <Button 
                            variant="primary" 
                            className="me-2" 
                            onClick={handleCloseDelete}
                            disabled={isDeleting}
                        >
                            No
                        </Button>
                        <Button 
                            variant="warning" 
                            onClick={() => handleDeleteProcess(applicant?.id)}
                            disabled={isDeleting}
                        >
                            {isDeleting ? 'Deleting...' : 'Yes'}
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showSuccessModal} onHide={handleSuccessClose} className="success-modal">
                <Modal.Header closeButton>
                    <Modal.Title className="h6">Records Deleted Successfully</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center mb-3">
                        <i className="fa-solid fa-circle-check text-success fs-1 mb-3"></i>
                        <p>The following records have been deleted:</p>
                        {deleteResult && (
                            <ul className="list-unstyled text-start ms-4">
                                <li>• Application ID: {deleteResult.applicationId}</li>
                                <li>• Loans Deleted: {deleteResult.loansDeleted}</li>
                                <li>• Payments Deleted: {deleteResult.paymentsDeleted}</li>
                            </ul>
                        )}
                    </div>
                    <div className="d-flex justify-content-center">
                        <Button 
                            variant="primary" 
                            onClick={handleSuccessClose}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <NavMain />
            <HeaderApplicant  applicant={applicant}/>
            <div className="main-content applicant-page">
                <div className="quick-links">
                    <Button variant="primary" onClick={handleShow}><i className="fa-solid fa-pencil"></i> Edit Details</Button>
                    <Button variant="primary" href={`/loan-processing/?id=${id}`}><i className="fa-solid fa-spinner"></i> Process Loan</Button>
                    <Button variant="warning" onClick={handleShowDelete}><i className="fa-solid fa-trash"></i> Send to Trash</Button>
                </div>
                <Container className="parent-container">
                    <Row>
                        <Col lg={8} className="applicant-details">
                            {/* Personal Information Section */}
                            <div className="details-section personal-info">
                                <h5 className="section-title">
                                    <i className="fa-solid fa-user me-2"></i>
                                    Personal Information
                                </h5>
                                <div className="section-content">
                                    <Row>
                                        <Col md={6}>
                                            <div className="info-group">
                                                <Row>
                                                    <Col xs={12} className="mb-3">
                                                        <span className="title">Last Name</span>
                                                        <span className="value">{applicant?.lastName || '--'}</span>
                                                    </Col>
                                                    <Col xs={12} className="mb-3">
                                                        <span className="title">First Name</span>
                                                        <span className="value">{applicant?.firstName || '--'}</span>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <span className="title">Middle Name</span>
                                                        <span className="value">{applicant?.middleName || '--'}</span>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="info-group">
                                                <Row>
                                                    <Col xs={12} className="mb-3">
                                                        <span className="title">Birthday</span>
                                                        <span className="value">
                                                            {applicant?.birthday ? format(new Date(applicant.birthday), 'MM/dd/yyyy') : '--'}
                                                        </span>
                                                    </Col>
                                                    <Col xs={12} className="mb-3">
                                                        <span className="title">Gender</span>
                                                        <span className="value">{applicant?.gender || '--'}</span>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <span className="title">Civil Status</span>
                                                        <span className="value">{applicant?.civilStatus || '--'}</span>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>

                                    {applicant?.civilStatus === 'Married' && (
                                        <Row className="mt-4">
                                            <Col md={6}>
                                                <div className="info-group spouse-info">
                                                    <h6 className="group-title">Spouse Information</h6>
                                                    <Row>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Spouse Name</span>
                                                            <span className="value">{applicant?.marriedTo || '--'}</span>
                                                        </Col>
                                                        <Col xs={12}>
                                                            <span className="title">Spouse Contact No.</span>
                                                            <span className="value">{applicant?.telephoneNo || '--'}</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="info-group">
                                                    <Row>
                                                        <Col xs={12}>
                                                            <span className="title">Mother's Maiden Name</span>
                                                            <span className="value">{applicant?.mothersMaidenName || '--'}</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </div>
                            </div>


                            {/* Contact Information Section */}
                            <div className="details-section contact-info">
                                <h5 className="section-title">
                                    <i className="fa-solid fa-address-book me-2"></i>
                                    Contact Information
                                </h5>
                                <div className="section-content">
                                    <Row>
                                        <Col md={6}>
                                            <div className="info-group">
                                                <Row>
                                                    <Col xs={12} className="mb-3">
                                                        <span className="title">Mobile No. 1</span>
                                                        <span className="value">{applicant?.mobileNo1 || '--'}</span>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <span className="title">Mobile No. 2</span>
                                                        <span className="value">{applicant?.mobileNo2 || '--'}</span>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="info-group">
                                                <Row>
                                                    <Col xs={12}>
                                                        <span className="title">Email Address</span>
                                                        <span className="value">{applicant?.emailAddress || '--'}</span>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                            {/* Co-Maker Information Section */}
                            {applicant?.preApplication && (
                                <div className="details-section co-maker-info">
                                    <h5 className="section-title">
                                        <i className="fa-solid fa-user-group me-2"></i>
                                        Co-Maker Information
                                    </h5>
                                    <div className="section-content">
                                        <Row>
                                            <Col md={6}>
                                                <div className="info-group">
                                                    <Row>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Full Name</span>
                                                            <span className="value">{[applicant.preApplication.coMakerFirstName, applicant.preApplication.coMakerMiddleName, applicant.preApplication.coMakerLastName].filter(Boolean).join(' ') || '--'}</span>
                                                        </Col>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Contact</span>
                                                            <span className="value">{applicant.preApplication.coMakerContact || '--'}</span>
                                                        </Col>
                                                        <Col xs={12}>
                                                            <span className="title">Email</span>
                                                            <span className="value">{applicant.preApplication.coMakerEmail || '--'}</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="info-group">
                                                    <Row>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Province</span>
                                                            <span className="value">{applicant.preApplication.coMakerProvince || '--'}</span>
                                                        </Col>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Municipality</span>
                                                            <span className="value">{applicant.preApplication.coMakerMunicipality || '--'}</span>
                                                        </Col>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Barangay</span>
                                                            <span className="value">{applicant.preApplication.coMakerBarangay || '--'}</span>
                                                        </Col>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">House / Street</span>
                                                            <span className="value">{applicant.preApplication.coMakerHouseStreet || '--'}</span>
                                                        </Col>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Zip Code</span>
                                                            <span className="value">{applicant.preApplication.coMakerZipCode || '--'}</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col md={6}>
                                                <div className="info-group">
                                                    <Row>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Source of Income</span>
                                                            <span className="value">{applicant.preApplication.coMakerSourceOfIncome || '--'}</span>
                                                        </Col>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Nature of Work</span>
                                                            <span className="value">{applicant.preApplication.coMakerNatureOfWork || '--'}</span>
                                                        </Col>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Employer</span>
                                                            <span className="value">{applicant.preApplication.coMakerEmployer || '--'}</span>
                                                        </Col>
                                                        <Col xs={12}>
                                                            <span className="title">Job Position</span>
                                                            <span className="value">{applicant.preApplication.coMakerJobPosition || '--'}</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="info-group">
                                                    <Row>
                                                        <Col xs={12} className="mb-3">
                                                            <span className="title">Monthly Income</span>
                                                            <span className="value">{applicant.preApplication.coMakerMonthlyIncome || '--'}</span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            )}

                            {/* Address Information Section */}
                            <div className="details-section address-info">
                                <h5 className="section-title">
                                    <i className="fa-solid fa-location-dot me-2"></i>
                                    Address Information
                                </h5>
                                <div className="section-content">
                                    <Row>
                                        <Col xs={12} className="mb-3">
                                            <span className="title">House / Street Address</span>
                                            <span className="value">{applicant?.street || '--'}</span>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <span className="title">Barangay</span>
                                            <span className="value">{applicant?.barangay || '--'}</span>
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <span className="title">City / Municipality</span>
                                            <span className="value">{applicant?.municipality || '--'}</span>
                                        </Col>
                                        <Col md={6}>
                                            <span className="title">Province</span>
                                            <span className="value">{applicant?.province || '--'}</span>
                                        </Col>
                                        <Col md={6}>
                                            <span className="title">Zip Code</span>
                                            <span className="value">{applicant?.zipCode || '--'}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                            {/* ID Information Section */}
                            <div className="details-section id-info">
                                <h5 className="section-title">
                                    <i className="fa-solid fa-id-card me-2"></i>
                                    ID Information
                                </h5>
                                <div className="section-content">
                                    <Row>
                                        <Col md={6}>
                                            <span className="title">SSS / GSIS #</span>
                                            <span className="value">{applicant?.sssOrGsis || '--'}</span>
                                        </Col>
                                        <Col md={6}>
                                            <span className="title">Passport #</span>
                                            <span className="value">{applicant?.passport || '--'}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>

                            {/* Employment Information Section */}
                            <div className="details-section employment-info">
                                <h5 className="section-title">
                                    <i className="fa-solid fa-briefcase me-2"></i>
                                    Employment Information
                                </h5>
                                <div className="section-content">
                                    <Row>
                                        <Col xs={12} className="mb-3">
                                            <span className="title">Employer Name</span>
                                            <span className="value">{applicant?.employerDetails || '--'}</span>
                                        </Col>
                                        <Col xs={12} className="mb-3">
                                            <span className="title">Employer Address</span>
                                            <span className="value">{applicant?.employerAddress || '--'}</span>
                                        </Col>
                                        <Col md={6}>
                                            <span className="title">Employer Contact No.</span>
                                            <span className="value">{applicant?.employerContactNumber || '--'}</span>
                                        </Col>
                                        <Col md={6}>
                                            <span className="title">Job Position</span>
                                            <span className="value">{applicant?.employerLocation || '--'}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>

                        {/* Processed Loans Section */}
                        <Col lg={4}>
                            <div className="loan-list" ref={processedLoansRef}>
                                <h5 className="section-title">
                                    <i className="fa-solid fa-file-invoice-dollar me-2"></i>
                                    Processed Loans
                                </h5>
                                {loanProcessed && loanProcessed.length > 0 ? (
                                    [...loanProcessed]
                                        .sort((a, b) => new Date(b.dateGranted) - new Date(a.dateGranted))
                                        .map((loan, index) => (
                                            <ApplicantProcessedLoans 
                                                key={loan.id || index}
                                                date={loan.dateGranted}
                                                interval={loan.loanInterval}
                                                term={loan.loanTerm}
                                                amount={loan.amountGranted}
                                                interest={loan.interestRate}
                                                paymentList={loan.payments}
                                                id={loan.id}
                                                loanItem={loan}
                                            />
                                        ))
                                ) : (
                                    <div className="empty-state">
                                        <i className="fa-solid fa-file-circle-xmark"></i>
                                        <p>No processed loans yet</p>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default ApplicantPage;